import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { myLabVmConnectPoolReadinessApi, myLabVmConnectReadinessApi } from "../store/api";
import { appendParam, checkIfObjectNotEmpty, localStorageHelper } from "../utils";
import { toastNotification } from "../utils/toast";
import { statusCode } from "../constants/apis/apiStatus";
import { toasterFlags } from "../constants/componentConstants";
import { ROUTES } from "../constants/routesConstants";

const useConnectODL = ({
  startVm,
  route = ROUTES.MY_LABS,
  toShowClock = false,
  title = "myLabs.myLabs",
  isPooled,
  setShowLab,
  setConnectVmData,
  setShowErrorModal,
  setThreeMinTimerUp,
  setShowExtensionModal,
  setErrorMessage,
}) => {
  const [step, setStep] = useState(0);
  const [isConnectModalVisible, setIsConnectModalVisible] = useState(false);
  const [pooledConnectRetry, setPooledConnectRetry] = useState(0);
  const [timerId, setTimerId] = useState("");
  const history = useHistory();
  const connectRef = useRef();
  connectRef.current = isConnectModalVisible;

  const resetConnectModalData = () => {
    setIsConnectModalVisible(false);
    setStep(0);
    clearTimeout(timerId);
    setTimerId("");
    clearTimeout(localStorageHelper?.get("redirectTimerId"));
  };

  const resetConnectModalDataAndRetry = () => {
    setStep(0);
    clearTimeout(timerId);
    setTimerId("");
    clearTimeout(localStorageHelper?.get("redirectTimerId"));
    setPooledConnectRetry((prevstate) => prevstate + 1);
  };

  useEffect(() => {
    if (pooledConnectRetry === 1) {
      connectPooledVmFunction();
    } else if (pooledConnectRetry > 1) {
      setShowErrorModal(true);
    }
  }, [pooledConnectRetry]);
  const callback = async (stepNo) => await myLabVmConnectReadinessApi({ vm_id: startVm?.id, step: stepNo + 1 });

  const callbackPool = async (params, stepNo) => await myLabVmConnectPoolReadinessApi({ params });
  const [remainderSecs, setRemainderSecs] = useState(-1);

  const connectPooledVmFunction = async () => {
    let isConnectionEstablished = false;
    let countDownInterval = "";
    let localStep = 0;
    setStep(0);
    let retryCount = 1;
    let setTimeoutId = "";
    let connectVmData = "";
    let vm_id = "";
    let lab_type = -1;
    //    const retryConnection = () => {
    //      setTimeout(() => {
    //        if (!isConnectionEstablished) {
    //          localStep = 5;
    //          resetConnectModalDataAndRetry();
    //        }
    //      }, 300000);
    //    };
    const countDown = () => {
      setRemainderSecs((prevState) => prevState - 1);
    };
    const startCountDown = () => {
      setRemainderSecs(180);
      countDownInterval = setInterval(() => countDown(), 1000);
    };
    startCountDown();
    //retryConnection();
    setTimeout(() => {
      if (!isConnectionEstablished) {
        setThreeMinTimerUp(true);
        clearInterval(countDownInterval);
      }
    }, 180000);
    while (localStep <= 2) {
      if (!connectRef.current) {
        break;
      }
      let params = appendParam("", "stage", localStep + 1);
      params = appendParam(params, "sku", startVm.sku);
      params = appendParam(params, "tenant", startVm.tenant);
      if (localStep === 2) {
        params = appendParam(params, "vm_id", vm_id);
      }
      connectVmData = await new Promise((resolve) => {
        setTimerId(
          (setTimeoutId = setTimeout(
            () => resolve(callbackPool(params, localStep)),
            retryCount === 1 ? 0 : localStep === 2 ? 10000 : 60000
          ))
        );
      });

      if (!connectRef.current) {
        break;
      }

      if (checkIfObjectNotEmpty(connectVmData) && connectVmData.status === statusCode.Ok200) {
        if (localStep === 1) {
          vm_id = connectVmData?.data?.vm_id;
          lab_type = connectVmData?.data?.lab_type;
          setConnectVmData({ lab_type: lab_type });
        }
        setStep((prevState) => prevState + 1);
        localStep++;
        retryCount = 1;
      } else if ((checkIfObjectNotEmpty(connectVmData) && connectVmData.status !== statusCode.Ok200) || !connectVmData) {
        if (localStep === 0) {
          toastNotification(toasterFlags.ERROR, connectVmData?.data?.message);
          setStep(0);
          clearTimeout(timerId);
          setTimerId("");
          clearTimeout(localStorageHelper?.get("redirectTimerId"));
          setShowErrorModal(true);
          break;
        }
        if ((retryCount === 20 && localStep === 2) || (retryCount === 10 && localStep === 1)) {
          toastNotification(toasterFlags.ERROR, "Server is busy, please logout and retry after sometime.");
          resetConnectModalData();
          break;
        }
        ++retryCount;
      }
      clearTimeout(setTimeoutId);
    }
    clearTimeout(setTimeoutId);
    localStorageHelper?.set(
      "redirectTimerId",
      setTimeout(() => {
        if (localStep === 3 && connectRef.current && connectVmData?.status === statusCode.Ok200) {
          if (connectVmData?.data?.QUOTA === "DELETE-EXHAUSTED" && lab_type === 1) {
            setConnectVmData({ vm_id: vm_id, QUOTA: connectVmData?.data?.QUOTA });
            setThreeMinTimerUp(false);
            setPooledConnectRetry(0);
            setShowErrorModal(true);
            setErrorMessage(connectVmData?.data?.message);
            toastNotification(toasterFlags.ERROR, connectVmData?.data?.message);
          } else if (connectVmData?.data?.QUOTA === "EXHAUSTED") {
            setConnectVmData({ vm_id: vm_id, QUOTA: connectVmData?.data?.QUOTA });
            setShowExtensionModal(true);
            setThreeMinTimerUp(false);
            setPooledConnectRetry(0);
            toastNotification(toasterFlags.ERROR, connectVmData?.data?.message);
            resetConnectModalData();
          } else {
            setConnectVmData(connectVmData?.data);
            setShowLab(true);
            setThreeMinTimerUp(false);
            isConnectionEstablished = true;
            resetConnectModalData();
          }
        }
      }, 1000)
    );
  };

  const connectVmFunction = async () => {
    let localStep = 0;
    setStep(0);
    let retryCount = 1;
    let setTimeoutId = "";
    let connectVmData = "";
    while (localStep <= 4) {
      if (!connectRef.current) {
        break;
      }
      connectVmData = await new Promise((resolve) => {
        setTimerId((setTimeoutId = setTimeout(() => resolve(callback(localStep)), retryCount === 1 ? 0 : 10000)));
      });
      if (!connectRef.current) {
        break;
      }
      if (checkIfObjectNotEmpty(connectVmData) && connectVmData.status === statusCode.Ok200) {
        setStep((prevState) => prevState + 1);
        localStep++;
        retryCount = 1;
      } else if (
        checkIfObjectNotEmpty(connectVmData) &&
        (connectVmData.status === statusCode.BadRequest400 || connectVmData.status === statusCode.Forbidden403)
      ) {
        if (localStep === 0 || localStep === 4 || retryCount === 5) {
          toastNotification(toasterFlags.ERROR, connectVmData?.data?.message);
          resetConnectModalData();
          break;
        }
        ++retryCount;
      }
      clearTimeout(setTimeoutId);
    }
    clearTimeout(setTimeoutId);
    localStorageHelper?.set(
      "redirectTimerId",
      setTimeout(() => {
        if (localStep === 5 && connectRef.current && connectVmData?.status === statusCode.Ok200) {
          history.push(`${ROUTES.MY_LABS}/${startVm?.id}`, {
            connectVmData: connectVmData?.data,
            startVm,
            route,
            toShowClock,
            title,
            autoFullScreen: true,
          });
          resetConnectModalData();
        }
      }, 1000)
    );
  };

  useEffect(() => {
    if (isConnectModalVisible && startVm) {
      isPooled ? connectPooledVmFunction() : connectVmFunction();
    }
  }, [isConnectModalVisible, startVm, isPooled]);

  useEffect(() => {
    return () => {
      clearTimeout(localStorageHelper?.get("redirectTimerId"));
      localStorageHelper?.removeItem("redirectTimerId");
    };
  }, []);

  return { isConnectModalVisible, step, setIsConnectModalVisible, resetConnectModalData, remainderSecs };
};

export default useConnectODL;